module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_01_6DC79_1SD_G9F.a9f21445.png";